var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto"},[_c('h3',[_vm._v("systemd-cgtop")]),_c('pre',[_vm._v("    \t\t"+_vm._s(_vm.$store.state.systemd.cgtop || 'no-data')+"\n    \t")])])}
var staticRenderFns = []

export { render, staticRenderFns }